export const SET_SEARCH = "SET_SEARCH";
export const SET_SEARCH_LOADER = "SET_SEARCH_LOADER";
export const CLOSE_SEARCH_LOADER = "CLOSE_SEARCH_LOADER";
